import React, { useState, useEffect } from "react";
import { Container, Label, Input, FormGroup, Col } from 'reactstrap';
import { Formik, Form, } from 'formik';
import { Loading } from '../../share/loading'
// import { v4 as uuidv4 } from 'uuid';
// import { NumberWithCommas } from "../../share/NumberWithCommas";
// import CreateTableComponent from "../../share/CreateTableComponent";
import * as Yup from 'yup'
// import TextErrors from '../../share/TextErrors'
import '../../share/form.css';
// import { BsPlusLg } from "react-icons/bs";
import Swal from 'sweetalert2'
import { NumberWithCommas } from "../../share/NumberWithCommas";
import { useNavigate } from "react-router-dom";
import DataRegisterComponent from "../../share/DataRegisterComponent";

export function EntrepreneurCh24Announce10FormComponent() {
    const user = JSON.parse(localStorage.getItem("userData"))
    const [loading, setLoading] = useState(false);
    const [selectInnovation, setSelectInnovation] = useState([]);
    const navigate = useNavigate();
    const [selectInnovationId, setSelectInnovationId] = useState(null);
    const [detailCourseDataAr, setDetailCourseDataAr] = useState([]);
    const [findEndDate, setFindEndDate] = useState("");
    const [data, setData] = useState([]);
    const [conditionOne, setConditionOne] = useState(null);
    const [calculateAmount, setCalculateAmount] = useState(0);


    useEffect(() => {
        getCondition();
        getSupportInnovationByUser();
    }, [])

    const getCondition = async () => {
        let id = 8;
        try {
            let res = await fetch(`api/SupportForm/getConditionSupport/${id}`)
            let resJson = await res.json();
            // console.log(resJson.dataenum);
            // setConditionData(resJson.dataenum);

            resJson.dataenum?.map((condition) => {
                setConditionOne(condition.condition1);
                //   setConditionTwo(condition.condition2);
                //   setConditionDate(condition.conditionDate);
            })

        } catch (e) {
            // console.log('err => ',e)
        }
    }

    async function getSupportInnovationByUser() {
        setLoading(true)
        try {
            let postData = new FormData()
            postData.append("registerId", user.registerId)
            let res = await fetch(`api/SupportForm/getSupportInnovation`, {
                method: "POST",
                body: postData
            })
            let resJson = await res.json();
            setSelectInnovation(resJson.dataenum);
        } catch (e) {

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        let today = new Date().getFullYear();
        let monthToday = String(new Date().getMonth() + 1).padStart(2, '0');
        let dayToday = String(new Date().getDate()).padStart(2, '0');
        let formatToday = `${today}-${monthToday}-${dayToday}`;
        // console.log("formatToday",formatToday)
        let differenceToday = Math.abs(new Date(formatToday) - new Date(findEndDate));
        let daysDifferenceToday = differenceToday / (1000 * 60 * 60 * 24);
        if (daysDifferenceToday > 90) {
            Swal.fire({
                icon: "info",
                allowOutsideClick: false,
                allowEscapeKey: false,
                title: ``,
                html: `ไม่สามารถขอรับเงินช่วยเหลือหรืออุดหนุนได้ <br> เนื่องจาก เลขที่แบบขอรับความเห็นชอบ มีจำนวนเกิน 90 วัน`,
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            }).then((result) => {
                return navigate("/supporting")
            })
        }

    }, [findEndDate])



    useEffect(() => {
        detailCourseDataAr?.map((item) => {
            let { trainClass } = item

            let lastIndex = trainClass.slice(-1)
            lastIndex.map((data) => {
                setFindEndDate(data.endDate)
            })
        })

    }, [detailCourseDataAr])



    useEffect(() => {
        function calculateAmountSupport() {
            if (detailCourseDataAr.length > 0) {
                let amount = detailCourseDataAr?.map(({ sumValueEachCourse }) => sumValueEachCourse).reduce((prev, current) => prev + current)
                if (amount > conditionOne) {
                    Swal.fire({
                        icon: "info",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        title: "จำนวนเงินต้องไม่เกินเงื่อนไขที่กำหนด",
                        text: `จำนวน ${NumberWithCommas(conditionOne)} บาท`,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    })
                } else {
                    setCalculateAmount(amount);
                }
            } else {
                return;
            }
        }
        calculateAmountSupport();
    }, [detailCourseDataAr])


    const initialValues = {
        paymentName: "",
        selectInnovationNo: "",
    }

    const onSubmit = async (values) => {
        // console.log(values)
        if (selectInnovationId === null) {
            Swal.fire({
                icon: "info",
                allowOutsideClick: false,
                allowEscapeKey: false,
                title: "กรุณาเลือกเลขที่แบบขอรับความเห็นชอบ",
                text: "",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            })
        }
        if (calculateAmount === 0) {
            Swal.fire({
                icon: "info",
                allowOutsideClick: false,
                allowEscapeKey: false,
                title: "ไม่สามารถส่งคำขอได้ เนื่องจากไม่ผ่านเงื่อนไขที่กำหนด",
                text: "",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            })
        }


        let postData = new FormData();
        postData.append("supportInnovationId", selectInnovationId)
        postData.append("amount", calculateAmount)
        Object.entries(values).forEach(([key, value]) => {
            postData.append(key, value);
        });
        // console.log(postData);

        try {
            let res = await fetch("/api/SupportForm/saveSupportFormAnnounceTen", {
                method: "POST",
                body: postData
            });

            let resJson = await res.json();
            // console.log(resJson.dataenum);

            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "บันทึกข้อมูลสำเร็จ",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate("/supporting/")
                    }
                })
            } else {
                Swal.fire({
                    icon: "error",
                    title: "บันทึกข้อมูลไม่สำเร็จ",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        } catch (e) {
            // console.log(e)
        }
    }

    const validationSchema = Yup.object().shape({
        paymentName: Yup.string().required("กรุณาระบุ"),

    })
    async function getDataInnovationforEdit(e) {
        // console.log(e.target.value)
        setLoading(true)

        let postData = new FormData()
        postData.append("supportInnovationId", e.target.value)
        try {
            let res = await fetch("api/Support/getDataInnovationForEdit/", {
                method: "POST",
                body: postData
            })
            let resJson = await res.json();
            // console.log("resj",resJson.dataenum)
            await resJson.dataenum?.map((item) => {

                item = JSON.stringify(item).replace(/null/g, `""`);
                item = JSON.parse(item);
                setData((prev) => {
                    return { ...prev, ...item }
                })
            });
        } catch (e) {
            // console.log("err", e)
        } finally {
            setLoading(false)
        }
    }

    async function getInnovationCourseForEdit(e) {
        setLoading(true)
        let postData = new FormData()
        postData.append("supportInnovationId", e.target.value)
        try {
            let res = await fetch("api/Support/getInnovationCourseForEdit", {
                method: "POST",
                body: postData
            })
            let resJson = await res.json();

            await resJson.dataenum?.map((data) => {
                data.detailCourseInnovationAr?.map((detail) => {
                    console.log("detailInnovationId", detail.innovationId)
                    if (detail.innovationId !== null) {
                        detail["checkInNoCourse"] = "1"
                    } else {
                        detail["checkInNoCourse"] = "2"
                    }
                    const { trainClass } = detail
                    detail["sumValueEachCourse"] = ""
                    let sum = []
                    trainClass?.map((classItem) => {
                        if (classItem.inOutTypeId === "1") {
                            sum.push((Number(classItem.tutorHourAmount) * Number(classItem.tutorRate)) + Number(classItem.materialAmount))
                            // setSumCourse((prev) => prev+sum);
                        } else {
                            sum.push(Number(classItem.amount))
                            // setSumCourse((prev) => prev+sum);
                        }

                        Object.keys(classItem).forEach((key) => {
                            if (classItem[key] === null) {
                                classItem[key] = "";
                            }
                        });
                    })
                    let total = sum.reduce((accumulator, currentValue) => accumulator + currentValue);
                    detail["sumValueEachCourse"] = total

                    Object.keys(detail).forEach((key) => {
                        if (detail[key] === null) {
                            detail[key] = "";
                        }
                    });
                })

                setDetailCourseDataAr(data.detailCourseInnovationAr)

            });
        } catch (e) {
        } finally {
            setLoading(false)
        }
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize
        >
            {({ setFieldValue, values, touched, errors, isValid, dirty, handleBlur, handleChange, getFieldProps }) => {

                const selectInnovationIdFx = (e) => {
                    let found = selectInnovation.find(({ supportInnovationId }) => supportInnovationId == e.target.value)
                    // console.log("supportInnovationId", found.supportInnovationId)
                    setSelectInnovationId(found.supportInnovationId);
                }

                return (

                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        {!loading ? (
                            <div className="form-border">

                                <Form className='p-5 mb-4'>

                                    <Label
                                        style={{ fontWeight: "bold" }}
                                        className='customer-type text-center px-4'
                                    >
                                        คำขอรับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน ตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545
                                        <br />
                                        กรมพัฒนาฝีมือแรงงาน กระทรวงแรงงาน
                                    </Label>

                                    <div className="d-flex justify-content-center align-items-center mt-3">
                                        <span className="input-color w-50">เลือกเลขที่แบบขอรับความเห็นชอบ</span>
                                        <Input
                                            type="select"
                                            id="selectInnovationNo"
                                            name="selectInnovationNo"
                                            className={
                                                touched.selectInnovationNo && errors.selectInnovationNo
                                                    ? "input-error rounded-pill text-center input-color w-50"
                                                    : "rounded-pill text-center input-color w-50"
                                            }
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                                getDataInnovationforEdit(e)
                                                selectInnovationIdFx(e)
                                                getInnovationCourseForEdit(e)
                                            }}
                                            value={selectInnovationId}
                                        >
                                            <option defaultValue value={"กรุณาเลือก"}>
                                                กรุณาเลือก
                                            </option>
                                            {selectInnovation?.map((item, i) => (
                                                <option key={item.supportInnovationNo} value={item.supportInnovationId}>
                                                    {item.supportInnovationNo}
                                                </option>
                                            ))}
                                        </Input>
                                    </div>
                                    <FormGroup className="mt-3">
                                        <Label>
                                            {/* {NumberWithCommas(detailCourseDataAr?.map(({sumValueEachCourse}) => sumValueEachCourse).reduce((prev,current) => prev+current))} */}
                                            ดำเนินการฝึกอบรมฝีมือแรงงานเพื่อการพัฒนาทักษะความรู้ให้แก่ลูกจ้างเพื่อเป็นการสร้างสรรค์นวัตกรรมหรือนำเทคโนโลยีมาใช้ในการผลิตสินค้าหรือบริการ
                                            จำนวน {detailCourseDataAr?.length} หลักสูตร เป็นจำนวนเงิน {NumberWithCommas(calculateAmount)} บาท
                                        </Label>
                                    </FormGroup>

                                    <FormGroup className="mt-4">
                                        <Label className="mb-3 input-color">ข้อมูลผู้ขอเงินช่วยเหลือหรืออุดหนุน</Label>
                                        <DataRegisterComponent />
                                    </FormGroup>

                                    <FormGroup className="mt-3">
                                        <>
                                            <FormGroup>
                                                <Label>ชื่อผู้ประสานงาน</Label>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{data?.authoriseName}</p>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>เลขบัตรประจำตัวประชาชน ผู้ประสานงาน</Label>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{data?.authorisePersonalId}</p>
                                            </FormGroup>
                                            <div className="d-flex justify-content-between">
                                                <FormGroup className="w-50 mx-1">
                                                    <Label>เบอร์โทรศัพท์</Label>
                                                    <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{data?.coordinatePhone}</p>
                                                </FormGroup>
                                                <FormGroup className="w-50 mx-1">
                                                    <Label>เบอร์โทรศัพท์มือถือ</Label>
                                                    <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{data?.coordinateMobile}</p>
                                                </FormGroup>
                                            </div>


                                            <FormGroup>
                                                <Label>อีเมล</Label>
                                                <p style={{ lineHeight: "2rem" }} className="rounded-pill text-center input-color border border-1">{data.coordinateEmail}</p>
                                            </FormGroup>

                                        </>

                                    </FormGroup>


                                    <FormGroup className='mt-3'>
                                        <Label>
                                            มีความประสงค์ขอรับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545 เป็นจำนวนเงิน
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.amount && errors.amount ?
                                                <span
                                                    className="text-left text-danger px-1">
                                                    {errors.amount}
                                                </span>
                                                : null
                                            }
                                        </Label>
                                        <Input
                                            id="amount"
                                            name="amount"
                                            type="text"
                                            disabled={true}
                                            className={touched.amount && errors.amount ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={NumberWithCommas(calculateAmount)}
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>
                                            โดยขอรับเช็คขีดคร่อมสั่งจ่ายในนาม
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.paymentName && errors.paymentName ?
                                                <span
                                                    className="text-left text-danger px-1">
                                                    {errors.paymentName}
                                                </span>
                                                : null
                                            }
                                        </Label>
                                        <Input
                                            id="paymentName"
                                            name="paymentName"
                                            type="text"
                                            className={touched.paymentName && errors.paymentName ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.paymentName}

                                        />
                                    </FormGroup>

                                    <div className='d-flex'>
                                        <Input
                                            type="checkbox"
                                            invalid={errors.term ? true : false}
                                            name="term"
                                            id="term"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.term}
                                        />
                                        <Label
                                            for="term"
                                            className='mx-2 customer-type'
                                        >
                                            ข้าพเจ้ารับรองว่าข้อความดังกล่าวข้างต้นและเอกสารหลักฐานที่แนบคำขอถูกต้องและเป็นความจริงทุกประการ
                                        </Label>

                                    </div>

                                    <div className='d-flex justify-content-center align-items-center mt-5'>
                                        <button
                                            type="submit"
                                            className='btn-blue px-4 w-25'
                                        >
                                            ส่งคำขอ
                                        </button>
                                    </div>
                                </Form>
                            </div>

                        ) : (
                            <Loading />
                        )}

                    </Container>

                )
            }}

        </Formik>

    );

}
